import { motion, AnimatePresence } from "framer-motion"
import styled from "styled-components"

import * as icons from "./icons"

const StyledButton = styled(motion.button)`
  color: currentColor;
  padding: 4px;
  margin-bottom: auto;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  align-content: center;
  pointer-events: all;
`

const fadeInOutAnimation = {
  variants: {
    out: {
      opacity: 0,
      transition: {
        duration: 0.6,
      },
    },
    in: {
      opacity: 1,
      transition: {
        duration: 0.6,
      },
    },
  },
  initial: "out",
  animate: "in",
  exit: "out",
}

const ButtonIcon = ({ isVisible = true, onClick, iconName }) => {
  const Icon = icons[iconName]

  return (
    <AnimatePresence>
      {isVisible && (
        <StyledButton
          onClick={onClick}
          {...fadeInOutAnimation}
          whileTap={{
            scale: 1.2,
            color: "rgb(220, 180, 0)",
            backgroundColor: "rgba(54, 54, 54, 0.2)",
            transition: {
              duration: 0.3,
            },
          }}
        >
          <Icon />
        </StyledButton>
      )}
    </AnimatePresence>
  )
}

export default ButtonIcon
